import { render, staticRenderFns } from "./gsr_szh_report.vue?vue&type=template&id=2ce338a9&scoped=true"
import script from "./gsr_szh_report.vue?vue&type=script&lang=js"
export * from "./gsr_szh_report.vue?vue&type=script&lang=js"
import style0 from "./gsr_szh_report.vue?vue&type=style&index=0&id=2ce338a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce338a9",
  null
  
)

export default component.exports